import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IChangeShipMethodWidgetProps {
    onClose: () => void;
}

export const ChangeShipMethodWidget = ({
    onClose,
}: IChangeShipMethodWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt; <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_change_my_shipping_method"
                        defaultMessage="Change Shipping Method"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="On_the_eStore_home_page"
                                    defaultMessage="Step 1. On the eStore home page, click on ‘My Orders’ under ‘Quick Links’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Search_for_the_order_shipping_update"
                                    defaultMessage="Step 2. Search for the order you would like to update and click on the order number or ‘See Details’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Next_under_need_to_make_changes"
                                    defaultMessage="Step 3. Next, under ‘Need to make changes to your order?’ select ‘Change Shipping Method’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="A_dropdown_will_appear_shipping_update"
                                    defaultMessage="Step 4. A dropdown will appear next to ‘Shipping Method’ where you can select the shipping method desired"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="After_selecting_a_new_shipping_method"
                                    defaultMessage="Step 5. After selecting a new shipping method, a pop-up with confirm your changes and you will see the shipping method update instantly on the order"
                                />
                            </li>
                        </ol>
                    </div>
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Video_tutorial"
                                defaultMessage="Video Tutorial"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="How_to_change_the_shipping"
                                    defaultMessage="How to change the shipping method"
                                />
                                <iframe
                                    className="help-center-video"
                                    src="https://bcove.video/3vyYjzY"
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="video"
                                />
                                <FormattedMessage
                                    id="Learn_how_to_change_your_order_shipping"
                                    defaultMessage="Learn how to change your order shipping method"
                                />
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const changeShipMethodWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangeShipMethodWidget);

export default changeShipMethodWidgetContainer;
